import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetConstantPackagesQueryVariables = Types.Exact<{
	platform?: Types.InputMaybe<Types.Platform>;
	country: Types.Scalars['Country']['input'];
}>;

export type GetConstantPackagesQuery = {
	__typename?: 'Query';
	packages: Array<{
		__typename?: 'Package';
		id: string;
		cn: string;
		hs?: boolean | null;
		ht?: boolean | null;
		i: string;
		mt: Array<Types.MonetizationType>;
		p: number;
		sn: string;
		s: string;
		tn: string;
		ivfb: boolean;
	}>;
};

export const GetConstantPackagesDocument = gql`
	query GetConstantPackages($platform: Platform = WEB, $country: Country!) {
		packages(country: $country, platform: $platform, includeAddons: true) {
			id
			cn: clearName
			hs: hasSport(country: $country, platform: $platform)
			ht: hasTitles(country: $country, platform: $platform)
			i: icon
			mt: monetizationTypes
			p: packageId
			sn: shortName
			s: slug
			tn: technicalName
			ivfb: isVisibleFilterBar(country: $country, platform: $platform)
		}
	}
`;
